"use client";

import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as e from "react";
function t(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var r,
  n = {
    exports: {}
  };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
r = n, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var e = "", t = 0; t < arguments.length; t++) {
      var r = arguments[t];
      r && (e = a(e, n(r)));
    }
    return e;
  }
  function n(r) {
    if ("string" == typeof r || "number" == typeof r) return r;
    if ("object" != typeof r) return "";
    if (Array.isArray(r)) return t.apply(null, r);
    if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) return r.toString();
    var n = "";
    for (var o in r) e.call(r, o) && r[o] && (n = a(n, o));
    return n;
  }
  function a(e, t) {
    return t ? e ? e + " " + t : e + t : e;
  }
  r.exports ? (t.default = t, r.exports = t) : window.classNames = t;
}();
var a = t(n.exports);
var o = function o() {
    return e.createElement("div", {
      className: "DefaultStarComponent"
    }, String.fromCharCode(9733));
  },
  l = function l(_ref) {
    var t = _ref.halfStars,
      r = _ref.starRenderer,
      n = _ref.index,
      o = _ref.selectedIndex,
      l = _ref.hoverIndex;
    return e.createElement("div", {
      className: a("StarPickerButtonContent", {
        halfStars: t
      })
    }, r({
      index: n,
      selectedIndex: o,
      hoverIndex: l
    }));
  },
  s = function s(_ref2) {
    var t = _ref2.index,
      r = _ref2.selectedIndex,
      n = _ref2.hoverIndex,
      o = _ref2.onClick,
      s = _ref2.onHoverChange,
      d = _ref2.starRenderer,
      i = _ref2.halfStars,
      c = _ref2.disabled;
    var u = t <= r,
      f = null != n,
      v = f && t <= n;
    return e.createElement("button", {
      "aria-label": "button ".concat(t + 1),
      className: a("StarPickerButton", {
        disabled: c,
        halfStars: i,
        selected: u,
        addSelection: f && !u && v,
        removeSelection: f && u && !v,
        isHovered: n === t
      }),
      type: "button",
      onClick: function onClick() {
        o(t);
      },
      onMouseEnter: function onMouseEnter() {
        c || s(t);
      },
      onMouseLeave: function onMouseLeave() {
        c || s(null);
      },
      disabled: c
    }, e.createElement(l, {
      halfStars: i,
      starRenderer: d,
      index: t,
      selectedIndex: r,
      hoverIndex: n
    }));
  },
  d = function d(_ref3) {
    var t = _ref3.value,
      r = _ref3.onChange,
      n = _ref3.name,
      l = _ref3.className,
      d = _ref3.starCount,
      _ref3$size = _ref3.size,
      i = _ref3$size === void 0 ? 34 : _ref3$size,
      _ref3$disabled = _ref3.disabled,
      c = _ref3$disabled === void 0 ? !1 : _ref3$disabled,
      _ref3$halfStars = _ref3.halfStars,
      u = _ref3$halfStars === void 0 ? !1 : _ref3$halfStars,
      _ref3$resettable = _ref3.resettable,
      f = _ref3$resettable === void 0 ? !1 : _ref3$resettable,
      _ref3$starRenderer = _ref3.starRenderer,
      v = _ref3$starRenderer === void 0 ? o : _ref3$starRenderer;
    var _e$useState = e.useState(null),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      p = _e$useState2[0],
      x = _e$useState2[1],
      S = function S(e) {
        r && r(function (e, t, r, n) {
          var a = function (e, t) {
            return t ? (e + 1) / 2 : e + 1;
          }(e, r);
          return n && a === t ? null : a;
        }(e, t, u, f), n);
      },
      m = function m(e) {
        x(e);
      },
      h = d !== null && d !== void 0 ? d : 5,
      y = function (e, t) {
        return e ? t ? 2 * e - 1 : e - 1 : -1;
      }(t, u),
      b = u ? 2 * h : h;
    return e.createElement("div", {
      className: a("StarPicker", l),
      style: {
        fontSize: "".concat(i, "px")
      }
    }, _toConsumableArray(Array(b).keys()).map(function (t) {
      return e.createElement(s, {
        key: "star-".concat(t),
        index: t,
        selectedIndex: y,
        hoverIndex: p,
        onClick: S,
        onHoverChange: m,
        starRenderer: v,
        halfStars: u,
        disabled: c,
        size: i
      });
    }));
  };
export { d as StarPicker, d as default, o as defaultStarRenderer };
//# sourceMappingURL=index.js.map